import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    item: PropTypes.string,
    sort_order: PropTypes.number,
    tempId: PropTypes.number,
    handleUpdateItems: PropTypes.func,
  },
  getInitialState() {
    return {
      item: this.props.item,
    };
  },
  handleItemOnChange(e) {
    this.setState(
      {
        item: e.target.value,
      },
      function() {
        const item = {
          tempId: this.props.tempId,
          item: this.state.item,
          sort_order: this.props.sort_order,
        };
        this.props.handleUpdateItems(item);
      }.bind(this)
    );
  },
  componentDidMount() {},
  render() {
    return (
      <p>
        <input
          className="form-control mt5"
          type="text"
          placeholder={`${this.props.sort_order}.項目入力`}
          onChange={this.handleItemOnChange}
        />
      </p>
    );
  },
});
